document.addEventListener("click", function (e) {
  const anchor = e.target.closest('a[href^="#"]');
  if (!anchor) return;

  // Collection hybrid CLP jump bar uses scroll-margin + section JS; global handler
  // below preventDefault()s and uses a fixed 150px offset which breaks anchoring.
  if (anchor.closest(".clp-jump-links") || anchor.hasAttribute("data-clp-jump-anchor")) {
    e.preventDefault();
    return;
  }

  e.preventDefault();
  const targetId = anchor.getAttribute("href").trim();
  if (targetId === "#") return;

  const id = targetId.slice(1);
  if (!id) return;

  const targetElement = document.getElementById(id);
  if (!targetElement) return;

  const offset = targetElement.getBoundingClientRect().top + window.scrollY - 150;

  window.scrollTo({
    top: offset,
    behavior: "smooth",
  });
});
